const lodestarAppearances = new Set(["primary", "secondary", "destructive", "secondary-destructive", "borderless"]);
export const mapButtonAppearance = (appearance, themeMode) => {
  let actualAppearance = appearance;
  if (themeMode?.includes("ursa") && lodestarAppearances.has(actualAppearance)) {
    switch (actualAppearance) {
      case "primary":
        actualAppearance = "primary-filled";
        break;
      case "secondary":
        actualAppearance = "secondary-filled";
        break;
      case "destructive":
        actualAppearance = "destructive-filled";
        break;
      case "secondary-destructive":
        actualAppearance = "destructive-empty";
        break;
      case "borderless":
        actualAppearance = "primary-empty";
        break;
    }
  }
  return actualAppearance;
};
//# sourceMappingURL=mapButtonAppearance.js.map